import { serviceInstance as api } from "../service";
import { serviceUploadInstance as apiUpload } from "../service.upload";

import { FileGetDTO } from "./dto";

export const getFiles = async () => {
  const response = await api().get("/orden/errorfile");
  return response.data?.result?.data.map(file => new FileGetDTO(file))
};


export const sendFiles = async (data, client) => {
  let formData = new FormData();
  formData.append("file",data);

  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));
  const { username } = getEmail;

  const response = await apiUpload().post(`/orden?id_cliente=${client}&usuario=${username}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response;
};
export const sendStatusFiles = async (data) => {
  let formData = new FormData();
  formData.append("file",data);
  
  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));
  const { username } = getEmail;

  const response = await apiUpload().post(`/orden/manual?usuario=${username}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response;
};



